import { Component, OnInit, Input } from '@angular/core';
import {AssistanceService} from '../../../../../models/assistanceservice';
import {AssistanceCategory} from '../../../../../models/assistance-category';
@Component({
    selector: 'app-assistance-ticket-information',
    templateUrl: './assistance-ticket-information.component.html',
    styleUrls: ['./assistance-ticket-information.component.css'],
    standalone: false
})
export class AssistanceTicketInformationComponent implements OnInit {

  @Input() activeIndex: number;
  @Input() category: AssistanceCategory;
  @Input() service: AssistanceService;
  @Input() provider: any;
  @Input() assistancecase: any;
  @Input() editticket: any;

  car_size;
  constructor() { }

  ngOnInit() {
    
    
    this.car_size = this.editticket.car_size;
    
  }

  getContactPhones(contactPhones) {
    if (contactPhones == null) {
      return [];
    }

    return contactPhones.split(',');
  }
}
